import { format as dfFormat, parseISO } from 'date-fns';

// Locale-aware helpers for displaying money and dates.

export function formatCurrency(
  amount: number | string,
  currency = 'KZT',
  locale = 'ru-RU',
): string {
  const n = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(n)) return String(amount);
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(n);
}

export function formatDate(value: string | Date, pattern = 'dd.MM.yyyy'): string {
  const d = typeof value === 'string' ? parseISO(value) : value;
  try {
    return dfFormat(d, pattern);
  } catch {
    return String(value);
  }
}

export function isDesktop(): boolean {
  return typeof window !== 'undefined' && window.innerWidth > 768;
}

// period_month (1-12) -> ключ в locales.months.
const MONTH_KEYS = [
  'january', 'february', 'march', 'april', 'may', 'june',
  'july', 'august', 'september', 'october', 'november', 'december',
] as const;

/**
 * «Платёж за Май 2026» -- единый формат периода платежа на вебе (как mobile
 * formatPeriod). Раньше период показывался как «payments.period 5/2026» из-за
 * отсутствующего ключа. t нужен для названия месяца + локализованного шаблона.
 */
export function formatPeriod(
  t: (key: string, opts?: Record<string, unknown>) => string,
  month: number,
  year: number,
): string {
  const monthLabel = t(`months.${MONTH_KEYS[month - 1] ?? 'january'}`);
  return t('payments.period', { month: monthLabel, year });
}
